import React from 'react';
import PropTypes from 'prop-types';

import PageSubMenu from '../../components/PageSubMenu';

function GalleryToggler({ categories, ...props }) {
  const categoryLinks = categories.map(g => ({
    name: 'media-and-press-filtered',
    params: { gallery: g },
    title: g,
  }));
  return (
    <PageSubMenu
      {...props}
      title="Video Categories"
      items={[
        {
          name: 'media-and-press',
          title: 'All Videos',
        },
      ].concat(categoryLinks)}
    />
  );
}

GalleryToggler.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default GalleryToggler;



// WEBPACK FOOTER //
// ./src/pages/VideoGallery/GalleryToggler.js